import axios from 'axios';
import { apiUrl } from './apiUrl';
axios.defaults.headers.common['Authorization'] = localStorage.getItem('loginToken') || '';

export const getAll = size =>
    axios.get(`${apiUrl}/services`)

export const update = service =>
    axios.put(`${apiUrl}/services`, service)

export const activate = service => {
    let s = service;
    s.active = true;
    return axios.put(`${apiUrl}/services`, s);
}

export const deactivate = service => {
    let s = service;
    s.active = false;
    return axios.put(`${apiUrl}/services`, s);
}

export const create = service =>
    axios.post(`${apiUrl}/services`, service)


// WEBPACK FOOTER //
// ./src/baseparking-api/Services.js